import { useRouter } from 'next/router';
import { createContext, FC, PropsWithChildren, useContext, useMemo } from 'react';

interface IProtectedRouteContextProps {
  isProtected: boolean;
}

const ProtectedRouteContext = createContext<IProtectedRouteContextProps>({
  isProtected: false,
});

export const ProtectedRouteProvider: FC<PropsWithChildren> = ({ children }) => {
  const { pathname } = useRouter();
  const protectedRouteContextValue = useMemo(
    () => ({
      isProtected: !['/login', '/coming-soon'].includes(pathname),
    }),
    [pathname],
  );

  return (
    <ProtectedRouteContext.Provider value={protectedRouteContextValue}>
      {children}
    </ProtectedRouteContext.Provider>
  );
};

export const useProtectedRoute = () => {
  const context = useContext(ProtectedRouteContext);
  if (!context) {
    throw new Error("You are using 'useProtectedRoute' hook outside of ProtectedRouteProvider");
  }
  return context;
};

export default ProtectedRouteContext;
